const GOVUKFrontend = require('./govuk-frontend-all.js');
import "./shared/feedback-form.js";
import "./shared/identity.js";
import "./shared/util.js";
import "./shared/feed-links";
import "./views/body-details.js";
import "./views/add-designated-standards.js";
import "./views/cab-management.js";
import "./views/mobile-sort.js";
import "./views/search.js";
import "./views/tabs-pagenumber-reset.js";
import "./views/file-upload.js";
import "./views/signature-capture.js";
import "./views/cab-details.js";
import "./views/pdf-status.js"
import "../scss/main.scss";
import "./shared/sentry-init.js";

GOVUKFrontend.initAll();